import React, { useEffect, useState } from 'react';
import ApiRequestor from '../../api_access/ApiRequestor';
import { connect } from 'react-redux';
import { IonButton, IonCard, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonRow, IonText } from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';

import { GetABMConsulta } from '../../store/ABMUsers/ABMConsulta/ABMConsultaActions';
import { ClientImageDefaultStateI } from '../../store/mainInfo/clientImageReducer';

import ToggleUserConsulta from './ToggleUserConsulta';
import Modal from '../Modal/Modal';

import './ABMUsers.css';

interface Consulta {
    client_access_name: string;
    client_access_permissions: any;
}

interface Props extends StateTypes, dispatchTypes {
    userConsulta: Consulta;
    backToTable: () => void;
}

const ModifyABMConsulta: React.FC<Props> = (props): JSX.Element => {

    const [dataConsulta, setDataConsulta] = useState({
        client_access_name: '',
        client_access_permissions: [''],
    });
    const [showModal, setShowModal] = useState(false);
    const [textModal, setTextModal] = useState('')
    const [errors, setError] = useState({ client_access_name: '', client_access_permissions: '' });

    useEffect(() => {
        setDataConsulta({
            client_access_name: props.userConsulta.client_access_name || '',
            client_access_permissions: props.userConsulta.client_access_permissions || [],
        });
    }, [props.userConsulta]);

    const getDataConsulta = (e: any) => {
        setDataConsulta({
            ...dataConsulta,
            [e.target.name]: e.detail.value!
        })
    }

    const validationConsulta = () => {
        const isEmpty = (value: any) => {
            if (typeof value === 'string') {
                return !value.trim();
            } else if (Array.isArray(value)) {
                return value.length === 0;
            } else {
                return !value;
            }
        };

        const errors = {
            client_access_permissions: isEmpty(dataConsulta.client_access_permissions) ? 'Debe seleccionar por lo menos un cliente.' : ''
        };

        setError(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;
    }

    const modifyUserConsulta = async (e: any) => {
        let valid = validationConsulta(); // Guarda el resultado para evitar una segunda ejecución innecesaria

        if (!valid) {
            let data: any = {
                body: {
                    client_access_name: dataConsulta.client_access_name,
                    client_access_permissions: dataConsulta.client_access_permissions,
                }
            };
            const response: any = await ApiRequestor.requestToApi(`/client-access/${dataConsulta.client_access_name}`, "PUT", data, "USER");

            if (response && response.status === 200) {
                setTextModal('Usuario Modificado Correctamente');
                props.getABMConsulta();
                setShowModal(true);
            } else {
                if (response && response.includes("status code 500")) {
                    setTextModal('No se pudo modificar el usuario. Por favor chequear los datos ingresados.');
                    setShowModal(true);
                }
            }
        }
    };


    const dismissModal = () => {
        setShowModal(false);
        if (textModal.includes('Usuario Modificado Correctamente')) {
            props.backToTable()
        }
    }

    const getToggleForm = (check: boolean, id: string) => {
        setDataConsulta((prevState) => {
            let updatedPermissions;
            if (check) {
                if (!prevState.client_access_permissions.includes(id)) {
                    updatedPermissions = [...prevState.client_access_permissions, id];
                } else {
                    updatedPermissions = [...prevState.client_access_permissions];
                }
            } else {
                updatedPermissions = prevState.client_access_permissions.filter(clientId => clientId !== id);
            }

            return {
                ...prevState,
                client_access_permissions: updatedPermissions
            };
        });
    };



    return (
        <div className="custom-content-scroll ion-padding">
            <IonCard>
                <IonCardTitle className="ion-text-center ABMUsersFormTitle">
                    MODIFICAR TIPO DE CONSULTAS
                </IonCardTitle>

                <IonGrid className="ion-margin ion-no-margin-top">
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='8' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Nombre
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput type="text"
                                    placeholder="Nombre"
                                    className="ion-padding ABMUsersFormInput"
                                    name="client_access_name"
                                    autocomplete="new-password"
                                    value={dataConsulta.client_access_name}
                                    onIonChange={(e) => {
                                        getDataConsulta(e)
                                    }} disabled>

                                </IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='12' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Clientes
                            </IonLabel>
                            <IonCard class='ABMConsultaCardClients'>
                                <IonRow>
                                    {
                                        props.clientImage.clientImage && props.clientImage.loading === false && props.clientImage.clientImage.map((client: any) => {
                                            const isChecked = dataConsulta.client_access_permissions.includes(client.service_name);

                                            return (
                                                <IonCol sizeMd='2' sizeLg='3' sizeXs='6' key={client.service_name}>
                                                    <ToggleUserConsulta
                                                        text={client.service_display_name}
                                                        id={client.service_name}
                                                        check={isChecked}
                                                        parentCallback={getToggleForm}
                                                    />
                                                </IonCol>
                                            )
                                        })
                                    }
                                </IonRow>
                            </IonCard>
                            <IonText>
                                <p className={errors.client_access_permissions ? "login-valid-text" : "ion-hide"}>{errors.client_access_permissions}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow className="ABMUsers-container-button  ion-margin-horizontal ion-margin-top ion-no-margin-bottom ion-justify-content-center">
                        <IonButton type="submit" fill="clear" onClick={modifyUserConsulta}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className="ion-padding ion-no-padding-bottom AMBUsersButton" />
                        </IonButton>
                        <IonButton fill="clear" onClick={props.backToTable}>
                            <IonIcon icon={closeCircleOutline} color="danger" className="ion-padding ion-no-padding-bottom AMBUsersButton" />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCard>

            <Modal
                modalConfirmation={{
                    textConfirmation: textModal,
                    onDidDimissConfirmModal: dismissModal,
                    isOpenModalConfirm: showModal,
                    onClickConfirmModal: dismissModal,
                }}
            />

        </div>
    )
}

interface StateTypes {
    clientImage: ClientImageDefaultStateI
}

const mapStateProps = (state: StateTypes) => {
    return {
        clientImage: state.clientImage,
    };
}

interface dispatchTypes {
    getABMConsulta: () => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getABMConsulta: () => dispatch(GetABMConsulta())
    };
}

export default connect(mapStateProps, mapDispatchToProps)(ModifyABMConsulta);